import Service from "./Service"

class AuthService extends Service {

    login = (requestBody) => this.postWithoutToken("/sessions", requestBody)

    logout = () => localStorage.removeItem("user")

    getCurrentUser = () => JSON.parse(localStorage.getItem("user"))
}

const authService = new AuthService()
export default authService